import React from 'react'
import { Bar } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import { formatDuration } from '../../utils/format'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

interface AgentPerformance {
  agentName: string
  avgResolutionTime: number
}

interface AgentPerformanceChartProps {
  data: AgentPerformance[]
}

export const AgentPerformanceChart: React.FC<AgentPerformanceChartProps> = ({ data }) => {
  const chartData = {
    labels: data.map((d) => d.agentName),
    datasets: [
      {
        label: 'Avg Resolution Time (minutes)',
        data: data.map((d) => d.avgResolutionTime / 60),
        backgroundColor: '#8b5cf6',
        borderRadius: 4,
        barThickness: 20
      }
    ]
  }

  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const
      },
      title: {
        display: true,
        text: 'Avg Resolution Time by Agent'
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          callback: function(value: any) {
            return formatDuration(value * 60)
          }
        }
      }
    }
  }

  return <Bar data={chartData} options={options} />
}
